export const SET_APPS_DATA = "SET_APPS_DATA";
export const SET_LIMIT_EXCEEDED_FOR_APP_INTEGRATION =
  "SET_LIMIT_EXCEEDED_FOR_APP_INTEGRATION";
export const SET_NEXT_APP_MODAL = "SET_NEXT_APP_MODAL";
export const UPDATE_WHATSAPP_PAY_STATUS = "UPDATE_WHATSAPP_PAY_STATUS";
